// 封装localstorage方法，只有在客户端才应用
import { isClient } from '@gateio/core-lib/src/utils'

const _isClient = isClient()

export const setLocalStorage = (key: string, value: string) => {
  if (_isClient) {
    localStorage.setItem(key, value)
  }
}

export const getLocalStorage = (key: string) => {
  if (_isClient) {
    return localStorage.getItem(key)
  }
  return ''
}

export const removeLocalStorage = (key: string) => {
  if (_isClient) {
    localStorage.removeItem(key)
  }
}

export const clearLocalStorage = () => {
  if (_isClient) {
    localStorage.clear()
  }
}
